import { render, staticRenderFns } from "./Typeahead2.vue?vue&type=template&id=517a1678&scoped=true&"
import script from "./Typeahead2.vue?vue&type=script&lang=js&"
export * from "./Typeahead2.vue?vue&type=script&lang=js&"
import style0 from "./Typeahead2.vue?vue&type=style&index=0&id=517a1678&scoped=true&lang=css&"
import style1 from "./Typeahead2.vue?vue&type=style&index=1&id=517a1678&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517a1678",
  null
  
)

export default component.exports